'use client';

import { motion, useReducedMotion } from 'framer-motion';
import type { ReactNode } from 'react';

interface RevealSectionProps {
  children: ReactNode;
  className?: string;
  /** 起始下移量（px），kudanil 风格用较小的位移 + 长时长 */
  y?: number;
  /** 揭示时长（秒） */
  duration?: number;
  /** 触发所需的可见比例 */
  amount?: number;
}

/**
 * 通用 section 揭示包装器，对标 kudanil.com 的滚动进场：
 * 进入视口时缓慢淡入 + 轻微上移，一次性触发（不来回）。节奏克制、时长偏长，
 * 配合 SmoothScrollProvider(Lenis) 的平滑滚动形成从容的编辑式观感。
 *
 * 降级：prefers-reduced-motion 直接静态渲染，无动画。
 */
export const RevealSection = ({ children, className, y = 40, duration = 1, amount = 0.15 }: RevealSectionProps) => {
  const prefersReducedMotion = useReducedMotion();

  if (prefersReducedMotion) {
    return <div className={className}>{children}</div>;
  }

  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount }}
      transition={{ duration, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
};
